
import Result, { EmptyResult } from '@package/services/src/Result';

import { BullseyeBucksService } from './services';
import { LoyaltyPoints, RedeemLoyaltyPoints } from './types';

export default class BullseyeBucksInteractor {
  public constructor(private bullseyeBucksService: BullseyeBucksService) {}

  public async getLoyaltyPoints(): Promise<Result<LoyaltyPoints>> {
    return this.bullseyeBucksService.getLoyaltyPoints();
  }

  public async redeemLoyaltyPoints(request: RedeemLoyaltyPoints): Promise<EmptyResult> {
    return this.bullseyeBucksService.redeemLoyaltyPoints(request);
  }
}
